<template>
    <div class="login">
        <div class="loader-container" v-if="loader">
            <Loader/>
        </div>
        <div class="container container-extra" v-if="!loader">
            <div class="centered">
                <img class="login-logo" src="../assets/logo_login.png" alt="" height="150" width="150">
                <div class="login-body">
                    <form v-on:submit.prevent="reset">
                        <div class="login-field">
                            <h3 style="font-size: 26px;padding: 20px">Set your new password</h3>
                            <div class="otp-input">
                            <span class="otp-input__prepend"><i class="fas fa-lock" style="color: #979797"
                                                                aria-hidden="true"></i></span>
                                <input type="password" placeholder="Enter new password" v-model="pin">
                            </div>
                            <small v-show="pass_error">{{pass_error}}</small>

                            <div class="otp-input">
                            <span class="otp-input__prepend"><i class="fas fa-lock" style="color: #979797"
                                                                aria-hidden="true"></i></span>
                                <input type="password" placeholder="Re-enter new password" v-model="confirmPin">
                            </div>
                            <small v-show="password_confirm_error">{{password_confirm_error}}</small>

                            <div class="login-footer">
                                <div>
                                    <button :disabled="!isDisable" class="btn btn-primary"
                                            style="padding: 6px 73px;margin-top: 20px;" >Request Reset
                                        Link
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "passwordReset",
        components: {
            'Loader': () => import("./Loader"),
        },
        data() {
            return {
                loader:false,
                pin: null,
                confirmPin: '',
                password_confirm_error: null,
                pass_error: null
            }
        },
        created() {

        },
        computed: {
            isDisable() {
                return (this.pin === this.confirmPin);
            },
            ...mapGetters(['user'])
        },
        mounted: function () {
            let self = this;
        },
        methods: {
            isValidPin: function () {
                if (this.pin.length === 5) {
                    this.pass_error = null;
                    return true;
                } else {
                    this.pass_error = "Need at least 5 number digit";
                    return false;
                }
            },
            isPasswordEqual: function () {
                if (this.pin === this.confirmPin) {
                    this.password_confirm_error = null;
                    return true;
                } else {
                    this.password_confirm_error = "Enter the same PIN number again";
                    return false;
                }
            },
            reset() {
                if (this.isValidPin()) {
                    if (this.isPasswordEqual()) {
                        const self = this;
                        self.loader = true;
                        axios.post(process.env.VUE_APP_API_URL + `/v2/bank/password/reset?token=` + self.user.token, {
                            new_password: self.pin,
                        })
                            .then(function (response) {
                                if (response.data.code === 200) {
                                    self.pass_error = "Updated Successfully";
                                    setTimeout(function () {
                                        self.$router.push({name:'loans'});
                                    }, 1000);
                                } else {
                                    self.pass_error = response.message;
                                    self.loader = false;
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            }
        }
    }
</script>
